module.exports = __webpack_public_path__ + "static/img/pic1.67032dad.png";